import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Snackbar,
  SnackbarContent
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import WarningIcon from "@material-ui/icons/Warning";
import classNames from "classnames";

const variantIcon = {
  warning: WarningIcon
};

const stylesSnackbar = theme => ({
  warning: {
    backgroundColor: theme.palette.error.dark
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["warning"]).isRequired
};

const MySnackbarContentWrapper = withStyles(stylesSnackbar)(MySnackbarContent);
const stylesMain = theme => ({
  margin: {
    margin: "8px"
  },
  textField: {
    flexBasis: 200
  }
});

class AddNewDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openSnackBar: false,
      snackbarMessage: ""
    };
  }
  handleOpenSnackBar = snackbarMessage => {
    this.setState({ openSnackBar: true, snackbarMessage: snackbarMessage });
  };

  handleCloseSnackBar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ openSnackBar: false });
  };
  render() {
    const {
      dialogOpen,
      dialogClose,
      dialogFor,
      entryName,
      handleChange,
      user,
      handleCreateDialogEntry,
      organisationId
    } = this.props;
    const { openSnackBar, snackbarMessage } = this.state;
    return (
      <div>
        <Dialog
          open={dialogOpen}
          onClose={dialogClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            Add{" "}
            {dialogFor === "addNewProduct"
              ? " Product"
              : dialogFor === "addNewUnit"
              ? " Unit"
              : dialogFor === "addDealQuality"
              ? " Quality"
              : dialogFor === "addBardanaCondition"
              ? " Bardana Condition"
              : dialogFor === "addDispatchCondition"
              ? " Dispatch Condition"
              : dialogFor === "addTransporter"
              ? " Transporter"
              : " "}
          </DialogTitle>
          <DialogContent>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <TextField
                required
                type="text"
                id="outlined-required"
                label={
                  dialogFor === "addNewProduct"
                    ? "Product Name"
                    : dialogFor === "addNewUnit"
                    ? "Unit Name"
                    : dialogFor === "addDealQuality"
                    ? "Quality Name"
                    : dialogFor === "addBardanaCondition"
                    ? " Bardana Condition Name"
                    : dialogFor === "addDispatchCondition"
                    ? " Dispatch Condition Name"
                    : dialogFor === "addTransporter"
                    ? " Transporter Name"
                    : ""
                }
                defaultValue={!entryName ? "" : entryName}
                onChange={handleChange("entryName")}
                margin="normal"
                variant="outlined"
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={e => {
                e.preventDefault();
                dialogClose();
              }}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={e => {
                e.preventDefault();
                if (!entryName) {
                  this.handleOpenSnackBar(
                    dialogFor === "addNewProduct"
                      ? "Product name is compulsory...!"
                      : dialogFor === "addNewUnit"
                      ? "Unit name is compulsory...!"
                      : dialogFor === "addDealQuality"
                      ? "Quality name is compulsory...!"
                      : dialogFor === "addBardanaCondition"
                      ? " Bardana Condition name is compulsory...!"
                      : dialogFor === "addDispatchCondition"
                      ? " Dispatch Condition name is compulsory...!"
                      : dialogFor === "addTransporter"
                      ? " Transporter name is compulsory"
                      : ""
                  );
                } else {
                  if (dialogFor === "addNewProduct") {
                    const product = {
                      productName: entryName,
                      organisationId: organisationId,
                      createdAt: new Date(),
                      userId: user.uid
                    };
                    handleCreateDialogEntry(product, dialogFor);
                  } else if (dialogFor === "addNewUnit") {
                    const unit = {
                      unitName: entryName,
                      organisationId: organisationId,
                      createdAt: new Date(),
                      userId: user.uid
                    };
                    handleCreateDialogEntry(unit, dialogFor);
                  } else if (dialogFor === "addDealQuality") {
                    const dealQuality = {
                      name: entryName,
                      organisationId: organisationId,
                      createdAt: new Date(),
                      userId: user.uid
                    };
                    handleCreateDialogEntry(dealQuality, dialogFor);
                  } else if (dialogFor === "addBardanaCondition") {
                    const bardanaCondition = {
                      name: entryName,
                      organisationId: organisationId,
                      createdAt: new Date(),
                      userId: user.uid
                    };
                    handleCreateDialogEntry(bardanaCondition, dialogFor);
                  } else if (dialogFor === "addDispatchCondition") {
                    const dispatchCondition = {
                      name: entryName,
                      organisationId: organisationId,
                      createdAt: new Date(),
                      userId: user.uid
                    };
                    handleCreateDialogEntry(dispatchCondition, dialogFor);
                  } else if (dialogFor === "addTransporter") {
                    const trasnporter = {
                      transporterName: entryName,
                      organisationId: organisationId,
                      createdAt: new Date(),
                      userId: user.uid
                    };
                    handleCreateDialogEntry(trasnporter, dialogFor);
                  } else {
                    console.log("Invalid Operation");
                  }
                }
              }}
              color="primary"
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          open={openSnackBar}
          autoHideDuration={3000}
          onClose={this.handleCloseSnackBar}
        >
          <MySnackbarContentWrapper
            onClick={this.handleCloseSnackBar}
            variant="warning"
            message={snackbarMessage}
          />
        </Snackbar>
      </div>
    );
  }
}
AddNewDialog.propTypes = {
  classes: PropTypes.object.isRequired
};
export default withStyles(stylesMain)(AddNewDialog);
